export default __webpack_public_path__ + "static/media/SE-marketing-page-6.17cc82b6.jpg";